import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import { DollarIcon, CurrencyIcon } from './Icons';
import './Donation.css';

const Donation = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="donation" className="donation">
      <div className="container">
        <div className="section-header">
          <h2>{t.donationTitle}</h2>
          <p>{t.donationIntro}</p>
        </div>

        <div className="donation-grid">
          <div className="donation-card">
            <h3>
              <div className="donation-icon">
                <DollarIcon />
              </div>
              {t.donateUSD}
            </h3>
            <p>{t.usdDonationDesc}</p>
            
            <div className="bank-details">
              <div className="bank-detail-row">
                <span className="bank-detail-label">{t.bankName}:</span>
                <span className="bank-detail-value">{t.mashreqBank}</span>
              </div>
              <div className="bank-detail-row">
                <span className="bank-detail-label">{t.accountName}:</span>
                <span className="bank-detail-value">{t.mandolaOrg}</span>
              </div>
              <div className="bank-detail-row">
                <span className="bank-detail-label">{t.accountNumber}:</span>
                <span className="bank-detail-value">61060529</span>
              </div>
              <div className="bank-detail-row">
                <span className="bank-detail-label">{t.swiftCode}:</span>
                <span className="bank-detail-value">{t.contactForTransfer}</span>
              </div>
            </div>

            <button className="contact-btn" onClick={scrollToContact}>
              {t.contactForTransfer}
            </button>
          </div>

          <div className="donation-card">
            <h3>
              <div className="donation-icon">
                <CurrencyIcon />
              </div>
              {t.donateSDG}
            </h3>
            <p>{t.sdgDonationDesc}</p>
            
            <div className="bank-details">
              <div className="bank-detail-row">
                <span className="bank-detail-label">{t.bankName}:</span>
                <span className="bank-detail-value">{t.mashreqBank}</span>
              </div>
              <div className="bank-detail-row">
                <span className="bank-detail-label">{t.accountName}:</span>
                <span className="bank-detail-value">{t.mandolaOrg}</span>
              </div>
              <div className="bank-detail-row">
                <span className="bank-detail-label">{t.accountNumber}:</span>
                <span className="bank-detail-value">61060518</span>
              </div>
            </div>

            <button className="contact-btn" onClick={scrollToContact}>
              {t.contactForTransfer}
            </button>
          </div>
        </div>

        <div className="donation-note">
          <p>
            {language === 'ar' 
              ? 'للتبرعات الكبيرة أو الشراكات المؤسسية، يرجى الاتصال بنا مباشرة'
              : 'For large donations or corporate partnerships, please contact us directly'}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Donation;
